module.exports = __webpack_public_path__ + "img/dipuo-qholosha.43acd3ab.png";